import * as React from 'react'
require('../base.module.scss')
import * as st from './Spinner.module.scss'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

const TRANSPARENT_1PX_GIF =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export interface SpinnerProps {
    fillHeight?: boolean
    className?: string
}

export const Spinner: React.ComponentType<SpinnerProps> = (props:  SpinnerProps) => {
    const className = extractClassNamesFromProps(props, st.spinner, { [st.fillHeight]: props.fillHeight })
    return (
    <span className={className}>
        {props.fillHeight ? (
            <img className={st.spaceHolder} src={TRANSPARENT_1PX_GIF} />
        ) : null}
    </span>
    )
}

// Add displayName to preserve the component name on snapshot testing
Spinner.displayName = 'Spinner'
